export default [
    "Additional Information",
    "MyFlexiPlan Purchase Amount",
    "Monthly Price"
];
